import React from 'react';
import { Mail, Send } from 'lucide-react';
import Hero from '../components/ui/Hero';
import { motion } from 'framer-motion';

const ContactPage = () => {
  const heroImage = "https://nifmkzddenyukgjcdetc.supabase.co/storage/v1/object/public/animatronics_data/logo_light.webp";

  return (
    <div>
      <Hero
        title="Contact Us"
        description="Get in touch with us for any questions or inquiries"
        backgroundImage={heroImage}
        compact
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Quick Contact */}
          <div className="space-y-6">
            <div className="card p-6 bg-gradient-to-br from-background-secondary to-background">
              <h2 className="text-xl font-semibold text-content-primary mb-6">Quick Contact</h2>
              <motion.div 
                className="flex items-center gap-3 text-content-secondary"
                whileHover={{ x: 10 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <div className="p-2 bg-brand/10 rounded-lg">
                  <Mail className="w-5 h-5 text-brand" />
                </div>
                <div>
                  <div className="text-sm text-content-secondary">Email</div>
                  <a href="mailto:contact@animatronicdatabase.com" className="text-content-primary hover:text-brand">
                    contact@animatronicdatabase.com
                  </a>
                </div>
              </motion.div>
            </div>

            {/* Advertising Section */}
            <motion.div 
              className="card p-6 bg-gradient-to-br from-brand/20 to-background"
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <h2 className="text-xl font-semibold text-content-primary mb-4">Advertising Opportunities</h2>
              <p className="text-content-secondary mb-6">
                Looking to promote your business? We offer various advertising options to reach our engaged audience of animatronic enthusiasts and industry professionals.
              </p>
              <a 
                href="/advertising"
                className="btn-primary inline-flex items-center gap-2 group"
              >
                Learn More
                <Send className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
            </motion.div>
          </div>

          {/* Contact Form */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="card p-6 bg-gradient-to-br from-background to-background-secondary"
          >
            <h2 className="text-xl font-semibold text-content-primary mb-6">Send us a Message</h2>
            <form 
              name="contact" 
              method="POST" 
              data-netlify="true"
              netlify-honeypot="bot-field"
              className="space-y-4"
            >
              <input type="hidden" name="form-name" value="contact" />
              <input type="hidden" name="subject" value="New Contact Form Submission" />
              <p className="hidden">
                <label>
                  Don't fill this out if you're human: <input name="bot-field" />
                </label>
              </p>
              
              <div>
                <label className="block text-sm font-medium text-content-secondary mb-1">
                  Name *
                </label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-2.5 bg-background border border-gray-800 rounded-lg text-content-primary placeholder-content-secondary focus:ring-2 focus:ring-brand focus:border-brand transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-content-secondary mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-2.5 bg-background border border-gray-800 rounded-lg text-content-primary placeholder-content-secondary focus:ring-2 focus:ring-brand focus:border-brand transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-content-secondary mb-1">
                  Message *
                </label>
                <textarea
                  name="message"
                  required
                  rows={6}
                  className="w-full px-4 py-2.5 bg-background border border-gray-800 rounded-lg text-content-primary placeholder-content-secondary focus:ring-2 focus:ring-brand focus:border-brand transition-colors resize-none"
                ></textarea>
              </div>

              <motion.button
                type="submit"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="w-full btn-primary inline-flex items-center justify-center gap-2"
              >
                <Send className="w-4 h-4" />
                Send Message
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;